import React from 'react';
import { getThemeProvider } from './getThemeProvider';
import type { ThemeProvider } from 'fe-lib-theme-types';

const { getThemeValue, subscribe } = getThemeProvider();

export interface WithThemeProps {
  $theme: ThemeProvider['getThemeValue'];
}

export function withHsTheme<P>(
  Comp: React.ComponentType<P>,
): React.ComponentType<Omit<P, keyof WithThemeProps>> {
  const WithHsTheme = React.forwardRef((props, ref) => {
    const [, setTrigger] = React.useState(Date.now());

    React.useEffect(() => {
      return subscribe(() => setTrigger(Date.now()));
    }, [setTrigger]);

    return (
      <Comp
        {...{
          innerRef: ref, // support styled-components v3
          ...props,
        }}
        ref={ref}
        $theme={getThemeValue}
      />
    );
  }) as React.ComponentType<Omit<P, keyof WithThemeProps>>;

  WithHsTheme.displayName = `WithHsTheme(${getDisplayName(Comp)})`;

  return WithHsTheme;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
